module.exports = __webpack_public_path__ + "img/DSCF9985.2ed85134.2ed85134.jpg";